var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1973_21923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 12.833C14.6666 13.5924 15.2822 14.208 16.0416 14.208C16.801 14.208 17.4166 13.5924 17.4166 12.833C17.4166 12.0736 16.801 11.458 16.0416 11.458C15.2822 11.458 14.6666 12.0736 14.6666 12.833Z",
    stroke: "#2E77D0",
    strokeWidth: 1.90385
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.325 7.33301C17.3851 7.03682 17.4167 6.73027 17.4167 6.41634C17.4167 3.88504 15.3646 1.83301 12.8333 1.83301C10.3021 1.83301 8.25 3.88504 8.25 6.41634C8.25 6.73027 8.28156 7.03682 8.34169 7.33301",
    stroke: "#2E77D0",
    strokeWidth: 1.90385
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41674 7.32746H14.6667C17.2594 7.32746 18.5558 7.32746 19.3613 8.1333C20.1667 8.93915 20.1667 10.2361 20.1667 12.8301V14.6643C20.1667 17.2583 20.1667 18.5553 19.3613 19.3612C18.5558 20.167 17.2594 20.167 14.6667 20.167H9.16674C5.70977 20.167 3.98129 20.167 2.90734 19.0926C1.8334 18.0181 1.8334 16.2888 1.8334 12.8301V10.9959C1.8334 7.53726 1.8334 5.80794 2.90734 4.73348C3.77184 3.86857 5.06047 3.69989 7.33341 3.66699H9.16674",
    stroke: "#2E77D0",
    strokeWidth: 1.90385,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1973_21923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.693580ddb5d64c77a586cee1c081143e.svg";
export { ForwardRef as ReactComponent };